import {
  CHAT_USER_LIST,
  CHAT_USER_LIST_SEARCH,
  GET_ACTIVE_PROPERTY_LIST,
  GET_RECENT_CHAT_LIST,
  UPDATE_CHAT_STATUS,
} from "../types";
import strings from "translate/language";
import { errorToast, unAuthorizedError } from "utils/httpClient";
import chatService from "reduxStore/service/chatService";

export const getUserListChat = (item) => async (dispatch) => {
  try {
    const res = await chatService.getAllUserListForChat(item);
    if (res.data.status === 200) {
      if (item?.isSearch) {
        dispatch({
          type: CHAT_USER_LIST_SEARCH,
          payload: res.data,
        });
        dispatch({
          type: CHAT_USER_LIST,
          payload: null,
        });
      } else {
        dispatch({
          type: CHAT_USER_LIST,
          payload: res.data,
        });
        dispatch({
          type: CHAT_USER_LIST_SEARCH,
          payload: null,
        });
      }
    } else {
      dispatch({
        type: CHAT_USER_LIST_SEARCH,
        payload: null,
      });
      dispatch({
        type: CHAT_USER_LIST,
        payload: [],
      });
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};
export const getRecentChatList = (item) => async (dispatch) => {
  try {
    const res = await chatService.getUserListForChating(item);
    if (res.data.status === 200) {
      dispatch({
        type: GET_RECENT_CHAT_LIST,
        payload: res.data,
      });
    }
    else {
      dispatch({
        type: GET_RECENT_CHAT_LIST,
        payload: [],
      });
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};
export const chatStatusUpdate = (item) => async (dispatch) => {
  try {
    const res = await chatService.userChatStatusUpdate(item);
    if (res.data.status === 200) {
      dispatch({
        type: UPDATE_CHAT_STATUS,
        payload: res.data,
      });
    } else {
      dispatch({
        type: UPDATE_CHAT_STATUS,
        payload: [],
      });
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};
export const getActivePropertys = (item) => async (dispatch) => {
  try {
    const res = await chatService.getActivePropertyList(item);
    if (res.data.status === 200) {
      dispatch({
        type: GET_ACTIVE_PROPERTY_LIST,
        payload: res.data,
      });
    } else {
      dispatch({
        type: GET_ACTIVE_PROPERTY_LIST,
        payload: [],
      });
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};

export const getPropertyUserList = (item) => async (dispatch) => {
  try {
    const res = await chatService.getPropertyUserListForChat(item);
    if (res.data.status === 200) {
      dispatch({
        type: GET_RECENT_CHAT_LIST,
        payload: res.data,
      });
    }
    else {
      dispatch({
        type: GET_RECENT_CHAT_LIST,
        payload: [],
      });
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};
